// <COMPONENT>.<ELEMENT>, SCREAMING_SNAKE both sides, exactly one dot.
export const REWAMP_KEY_GRAMMAR = /^[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)*\.[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)*$/;

export const isRewampKey = (key) => typeof key === "string" && REWAMP_KEY_GRAMMAR.test(key);
